// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-home-G":"G_power-ocean-home-G__tPKIy"};